export default "__VITE_ASSET__BWsDO5yJ__"